import { useEffect } from 'react';
import SwiperCore from 'swiper';
import { Slider } from 'ui';
import { getCookie, setCookie } from 'utils';

import { ProductPageBanner } from '@/modules/product/api/banners';
import { BANNERS_STATE_COOKIE_NAME } from '@/modules/product/utils';
import { getBannerSlotName, renderBanner } from '@/shared/banners/utils';

import styles from './BannersAsProductTile.module.scss';
import { imageBreakpoints } from './utils';

export function BannersAsProductTile({
  banners,
  name,
  initialSlide,
}: {
  banners: ProductPageBanner[];
  name: 'product_grid_pos_15' | 'product_grid_pos_39';
  initialSlide: number;
}) {
  const updateCookie = (slide: number) => {
    const bannerStateCookie = getCookie(BANNERS_STATE_COOKIE_NAME);

    if (!bannerStateCookie) {
      return;
    }

    const oldValue = JSON.parse(bannerStateCookie);

    const newValue = {
      ...oldValue,
      [name]: slide === banners.length - 1 ? 0 : slide + 1,
    };

    setCookie(BANNERS_STATE_COOKIE_NAME, JSON.stringify(newValue));
  };

  const handleSlideChange = (swiper: SwiperCore) => {
    updateCookie(swiper.realIndex);
  };

  useEffect(() => {
    updateCookie(initialSlide);
  }, []);

  return (
    <div className={styles.BannersAsProductTile__wrapper}>
      <Slider
        hasArrows={banners.length > 1}
        loop
        initialSlide={initialSlide}
        onSlideChange={handleSlideChange}
        autoplay
      >
        {banners.map((banner, index) => (
          <div
            key={banner.productBannerId}
            className={styles.BannersAsProductTile__slide}
          >
            {renderBanner(
              banner.layout,
              null,
              banner.name,
              index + 1,
              getBannerSlotName(banner.location),
              imageBreakpoints
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
}
